/**
 * Pave numerique d'un montant (maquette paiement.html) : 1 a 9, 00, 0, ⌫,
 * touches d'au moins 64 px, 10 px d'espace.
 */
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import BackspaceOutlinedIcon from '@mui/icons-material/BackspaceOutlined';
import { palette } from '../app/theme';

const KEY_SX = {
    minHeight: 68, fontSize: 26, fontWeight: 700, borderRadius: '12px', borderWidth: 2,
    color: palette.text, borderColor: palette.border, bgcolor: palette.surface,
    '&:hover': { borderWidth: 2 },
};

export default function PaveMontant({ label, disabled = false, onChiffres, onEffacer }) {
    const touche = (t) => (
        <Button key={t} variant="outlined" disabled={disabled} onClick={() => onChiffres(t)} sx={KEY_SX}>
            {t}
        </Button>
    );
    return (
        <Box role="group" aria-label={label} sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px' }}>
            {['1', '2', '3', '4', '5', '6', '7', '8', '9', '00', '0'].map(touche)}
            <Button variant="outlined" aria-label="Effacer un chiffre" disabled={disabled} onClick={onEffacer} sx={KEY_SX}>
                <BackspaceOutlinedIcon sx={{ fontSize: 30 }} />
            </Button>
        </Box>
    );
}
